<template>
  <section
    class="slide sec3 whiteSlide kenBurns bg-white overflow-hidden opacity-0 fixed w-full h-full text-black"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap cursor-default table-cell align-middle">
          <div class="fix-width max-w-1114px ml-auto mr-auto">
            <ul class="grid sec-details sec-details2 ml-spc16 mr-spc16">
              <li
                class="col-6-12 mt-spc13 max-w-589 w-full pl-6 pr-6 block text-center"
                id="productImage1"
              >
                <SliderOne :slideDatas="mjSliderData" />
              </li>
              <li class="col-6-12 left max-w-589 w-full pl-6 pr-6 block">
                <SectionDetailsContent
                  :title="title"
                  :subtitle="subtitle"
                  :sizes="sizes"
                  :prices="prices"
                  :colors="colors"
                  :fabrics="fabrics"
                  btn1title="Purchase"
                  btn2title="Enquiries"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderOne from "../sliders/slider1/SliderOne";
import SectionDetailsContent from "../common/SectionDetailsContent";

let mjSliderData = {
  sliderID: "28",
  mjSliders: [
    {
      active: true,
      img: require("@/assets/images/products/thumbp2p1.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbp2p2.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbp2p3.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbp2p4.png")
    }
  ]
};

export default {
  name: "Section5",
  components: {
    SectionDetailsContent,
    SliderOne
  },
  data: function() {
    return {
      mjSliderData,
      title: "LINENS",
      subtitle: "THE POINT-TO-POINT",
      sizes: {
        sticks: '55" x 85” LG // 55” x 55” SQ'
      },
      colors: {
        clr: "Grey Stripe G // Red Stripe R"
      },
      fabrics: {
        fabric: "madisonjames Belgian Linen"
      },
      prices: {
        price1: "$460(LG) // $380 (SQ)"
      }
    };
  }
};
</script>

<style scoped>
</style>